import { useGetOrganizationInvitation } from "@/api";
import NumerousLogo from "@/components/logo/NumerousLogo";
import Loading from "@/components/ui/loading";
import { Invitation } from "./Invitation";
import { InvitationError } from "./InvitationError";

type Props = {
  invitationId: string;
};

export const OrganizationInvitation = ({ invitationId }: Props) => {
  const { data, loading, error } = useGetOrganizationInvitation({
    invitationId
  });

  const invitation =
    data?.organizationInvitation?.__typename === "OrganizationInvitation" &&
    data.organizationInvitation;

  const invitationError =
    error ||
    data?.organizationInvitation?.__typename === "OrganizationNotFound" ||
    data?.organizationInvitation?.__typename ===
      "OrganizationInvitationNotFound";

  if (invitationError)
    return (
      <div className="max-w-xl w-4/5 h-full flex flex-col items-center py-4">
        <NumerousLogo type="fullLogo" size="sm" />
        <div className="flex flex-col gap-12 items-center justify-center h-full pb-8">
          <InvitationError error={error} />
        </div>
      </div>
    );

  if (loading || !invitation) return <Loading size="md" />;

  return <Invitation invitation={invitation} />;
};
